<div class="background-wrapper-image"
  role="main"
  tabindex="-1"
  [attr.aria-label]="'ACCESSIBILITY.WAITING_ROOM' | translate"
  [ngStyle]="{backgroundImage: 'url(' + (backgroundImg$ | async).backgroundImage + ')'}">
  <div class="sr-only" aria-live="polite" aria-atomic="true">
    {{ 'ACCESSIBILITY.WAITING_ROOM_DESCRIPTION' | translate }}
  </div>

  @if ({ appointments: appointments$ | async }; as waitingRoom) {
    @if (waitingRoom?.appointments?.length > 0) {
      <section class="appointment-info-for-patients-wrapper"
        role="list"
        [attr.aria-label]="'ACCESSIBILITY.APPOINTMENT_LIST' | translate">
        <h1 class="sr-only">{{ 'ACCESSIBILITY.CURRENT_APPOINTMENTS' | translate }}</h1>
        @for (appointment of waitingRoom.appointments; track appointment; let i = $index) {
          <div
            [attr.aria-label]="'ACCESSIBILITY.APPOINTMENT_ITEM' | translate : {index: i + 1, total: waitingRoom.appointments.length}"
            [attr.tabindex]="i === 0 ? '0' : '-1'"
            role="listitem"
            class="appointment-item">
            <app-multi-user-appointment-info-for-patients
              [appointment]="appointment">
            </app-multi-user-appointment-info-for-patients>
          </div>
        }
      </section>
    }
    @if (waitingRoom?.appointments?.length === 0) {
      <section
        class="no-appointments-message"
        role="region"
        [attr.aria-label]="'ACCESSIBILITY.NO_APPOINTMENTS' | translate">
        <h1 class="sr-only">{{ 'ACCESSIBILITY.NO_APPOINTMENTS_TITLE' | translate }}</h1>
        <p>{{ 'ACCESSIBILITY.NO_APPOINTMENTS_MESSAGE' | translate }}</p>
      </section>
    }
  }
</div>
